module.exports = __webpack_public_path__ + "img/17-s.3c85da3e.png";